import styles from "./styles.module.scss";
import React, { FunctionComponent, useMemo } from "react";
import { Stack, useTheme } from "@mui/material";
import { StringFormat } from "../../../models/StringFormat";
import { strings } from "../../../localization/LocalizedStrings";
import { ShortcutItem } from "../../ShortcutItem";
import { Icon, IconType } from "../../../icons";

export const ContentUnavailableNotice: FunctionComponent<IContentUnavailableNoticeProps> = ({
  isLoading,
  defaultVisible = false,
  items,
  emptyIconType,
  emptyTitle,
  emptyDescription,
  addButtonTitle,
  searchText,
  onAddItem,
  canAdd
}) => {
  const theme = useTheme();
  const visible = useMemo(() => {
    if (items === undefined || isLoading) {
      return defaultVisible;
    }
    return items.length == 0;
  }, [items]);
  return (
    <>
      {!items?.length && !isLoading && visible && (
        <Stack className={styles.noItemsStack}>
          <Icon
            type={searchText ? IconType.Search : emptyIconType}
            className={styles.noItemsIcon}
            style={{ color: theme.palette.primary.subtitle }}
          />
          <p className={styles.noItems}>
            {searchText ? StringFormat(strings.empty_search_title, searchText) : emptyTitle}
          </p>
          <p className={styles.noItemsSubtitle} style={{ color: theme.palette.primary.subtitle }}>
            {searchText ? strings.empty_search_description : emptyDescription}
          </p>
          {canAdd && !searchText && addButtonTitle && onAddItem && (
            <ShortcutItem
              className={styles.addButton}
              iconType={IconType.AddCircle}
              title={addButtonTitle}
              onClick={onAddItem}
            />
          )}
        </Stack>
      )}
    </>
  );
};

export interface IContentUnavailableNoticeProps {
  isLoading: boolean;
  defaultVisible?: boolean;
  items: any[] | undefined;
  emptyIconType: IconType;
  emptyTitle: string;
  emptyDescription: string;
  addButtonTitle?: string;
  searchText: string | undefined;
  onAddItem?: () => void;
  canAdd: boolean;
}
